import { render, staticRenderFns } from "./MediaTagHandling.vue?vue&type=template&id=2abd04e9&scoped=true&"
import script from "./MediaTagHandling.vue?vue&type=script&lang=js&"
export * from "./MediaTagHandling.vue?vue&type=script&lang=js&"
import style0 from "./MediaTagHandling.vue?vue&type=style&index=0&id=2abd04e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd04e9",
  null
  
)

export default component.exports